import { Injectable } from '@angular/core';
import { Crm } from './crm.class';

@Injectable({
  providedIn: 'root',
})
export class ZendeskService extends Crm {
  constructor() {
    super();
  }

  getTypeString() {
    return 'zendesk';
  }

  getDefaultLoginUrl() {
    return 'https://{subdomain}.zendesk.com';
  }

  getNewContactCreationMode() {
    return {
      mode: 'internal-form',
    };
  }

  canMakeIndirectSearch() {
    return false;
  }

  canChooseSearchType() {
    return false;
  }

  defaultSearchType() {
    return 'exact';
  }
}
